<li
  [attr.aria-current]="status() === 'CURRENT' ? 'step' : null"
  [ngClass]="[
    {
      COMPLETED: 'block size-2.5 rounded-full bg-primary hover:bg-primary-highlight',
      UPCOMING:
        'block size-2.5 rounded-full bg-outline dark:bg-outline-darkmode hover:bg-on-surface-disabled dark:hover:bg-on-surface-disabled-darkmode',
      CURRENT: 'relative flex items-center justify-center',
    }[status()],
  ]"
>
  @if (status() === 'CURRENT') {
    <span aria-hidden="true" class="absolute flex size-5 p-px">
      <span class="size-full rounded-full bg-primary-soft dark:bg-primary-soft-darkmode"></span>
    </span>
    <span
      aria-hidden="true"
      class="relative block size-2.5 rounded-full bg-primary dark:bg-primary-darkmode"
    ></span>
  }
  <span class="sr-only">
    <ng-content />
  </span>
</li>
